import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'any' // Add this to ensure your SEO service will be app-wide available
})
export class TitleService {
  constructor(private readonly title: Title, private readonly meta: Meta) { }

  updateTitle(title: string) {
    this.title.setTitle(title);
    this.meta.updateTag({ property: 'og:title', content: title });
  }

  updateOgUrl(url: string) {
    this.meta.updateTag({ property: 'og:url', content: url });
  }
  
  updateOgImage(image: string) {
    this.meta.updateTag({ property: 'og:image', content: image });
  }

  updateDescription(desc: string) {
    const description = (desc ?? '').replace(/<\/?[^>]+(>|$)/g, "");
    this.meta.updateTag({ name: 'description', content: description });
    this.meta.updateTag({ property: 'og:description', content: description });
  }
}
